/* Progressive enhancement for the server-rendered, browse-only product catalog. */
(() => {
  'use strict';
  if (window.PVSeriesCatalog) { window.PVSeriesCatalog.init(document); return; }
  const PAGE_SIZE = 12;
  const instances = new Map();
  const productId = value => /^[a-z0-9][a-z0-9-]{0,95}$/.test(value || '');
  const hashValue = () => { try { return decodeURIComponent(location.hash.slice(1)); } catch (_) { return ''; } };
  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-series-root]')];
    if (scope.matches && scope.matches('[data-series-root]')) roots.unshift(scope);
    roots.forEach(root => {
      if (instances.has(root)) return;
      const controller = new AbortController();
      const on = (el, event, handler) => { if (el) el.addEventListener(event, handler, { signal: controller.signal }); };
      const cards = Array.from(root.querySelectorAll('[data-series-product]'));
      const imageLink = card => card.querySelector('[data-series-image-open], [data-pv-product-link]');
      const search = root.querySelector('[data-series-search]');
      const category = root.querySelector('[data-series-category]');
      const world = root.querySelector('[data-series-world]');
      const catalogueScope = world ? 'across all collections' : 'in this collection';
      if (root.dataset.seriesTitle) document.title = `${root.dataset.seriesTitle} | PETSVILLE`;
      const clearSearch = root.querySelector('[data-series-search-clear]');
      const controls = root.querySelector('[data-series-controls]');
      const status = root.querySelector('[data-series-status]');
      const more = root.querySelector('[data-series-more]');
      const moreWrap = root.querySelector('[data-series-more-wrap]');
      const empty = root.querySelector('[data-series-empty]');
      // Leave native links and all server-rendered cards usable if a section is incomplete.
      if (!search || !category || !controls || !clearSearch || !status || !more || !moreWrap || !empty) return;
      let limit = PAGE_SIZE, matching = cards, composing = false;
      const available = new Set(cards.map(card => card.dataset.category));
      Array.from(category.options).forEach(option => { if (option.value !== 'all' && !available.has(option.value)) option.remove(); });
      const readState = () => {
        const url = new URL(location.href);
        search.value = url.searchParams.get('pvq') || '';
        category.value = url.searchParams.get('pvtype') || 'all';
        if (!category.value) category.value = 'all';
        if (world) { world.value = url.searchParams.get('pvworld') || 'all'; if (!world.value) world.value = 'all'; }
        limit = Math.max(PAGE_SIZE, Math.min(cards.length, Math.floor(Number(url.searchParams.get('pvshow'))) || PAGE_SIZE));
      };
      const saveState = (clearCardHash = false) => {
        const url = new URL(location.href);
        [['pvq', search.value.trim()], ['pvtype', category.value === 'all' ? '' : category.value], ['pvworld', world && world.value !== 'all' ? world.value : ''], ['pvshow', limit > PAGE_SIZE ? String(limit) : '']].forEach(([key, value]) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key));
        if (clearCardHash && /^#pv-card-/.test(url.hash)) url.hash = '';
        history.replaceState(history.state, '', url);
      };
      const announce = () => root.dispatchEvent(new CustomEvent('pv:catalog-rendered', { bubbles: true }));
      const render = () => {
        clearSearch.hidden = search.value.length === 0;
        const terms = search.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
        matching = cards.filter(card => (category.value === 'all' || card.dataset.category === category.value) && (!world || world.value === 'all' || card.dataset.world === world.value) && terms.every(term => (card.dataset.search || '').includes(term)));
        const visible = new Set(matching.slice(0, limit));
        cards.forEach(card => { card.hidden = !visible.has(card); });
        status.textContent = matching.length ? `Showing ${Math.min(limit, matching.length)} of ${matching.length} products${matching.length !== cards.length ? ` · ${cards.length} ${catalogueScope}` : ''}` : `No matches · ${cards.length} products ${catalogueScope}`;
        moreWrap.hidden = limit >= matching.length;
        more.textContent = `Load ${Math.min(PAGE_SIZE, Math.max(0, matching.length - limit))} more products`;
        empty.hidden = matching.length > 0;
      };
      const reveal = id => {
        const card = cards.find(item => item.dataset.productId === id && item.id === `pv-card-${id}`);
        if (!card) return null;
        if (!matching.includes(card)) { search.value = ''; category.value = 'all'; if (world) world.value = 'all'; render(); }
        const index = matching.indexOf(card);
        if (index >= limit) { limit = Math.ceil((index + 1) / PAGE_SIZE) * PAGE_SIZE; render(); }
        saveState();
        return card;
      };
      const showUnavailable = () => {
        const view = new URL(location.href).searchParams.get('view') || '';
        const legacy = hashValue().match(/^pv-(?:product|title)-(.+)$/);
        const unavailable = view.startsWith('pv-p-') || (legacy && (!productId(legacy[1]) || !cards.some(card => card.dataset.productId === legacy[1])));
        let notice = root.querySelector('[data-pv-product-unavailable]');
        if (unavailable && !notice) {
          notice = document.createElement('p');
          notice.className = 'pv-product-unavailable';
          notice.dataset.pvProductUnavailable = '';
          notice.setAttribute('role', 'status');
          notice.textContent = 'This product page is unavailable. Explore our products below.';
          root.prepend(notice);
        } else if (!unavailable && notice) notice.remove();
      };
      const syncLocation = () => {
        readState(); render();
        const hash = hashValue().match(/^pv-card-([a-z0-9][a-z0-9-]{0,95})$/);
        if (hash) reveal(hash[1]);
        showUnavailable(); announce();
      };
      const applyFilter = () => { limit = PAGE_SIZE; render(); saveState(true); announce(); };
      const clearFilters = () => { search.value = ''; category.value = 'all'; if (world) world.value = 'all'; applyFilter(); search.focus(); };
      on(controls, 'submit', event => { event.preventDefault(); if (!composing) applyFilter(); });
      on(search, 'compositionstart', () => { composing = true; });
      on(search, 'compositionend', () => { composing = false; applyFilter(); });
      on(search, 'input', () => { clearSearch.hidden = search.value.length === 0; if (!composing) applyFilter(); });
      on(clearSearch, 'click', () => { search.value = ''; applyFilter(); search.focus(); });
      on(category, 'change', applyFilter);
      if (world) on(world, 'change', applyFilter);
      on(root.querySelector('[data-series-reset]'), 'click', clearFilters);
      on(root.querySelector('[data-series-empty-reset]'), 'click', clearFilters);
      on(more, 'click', () => {
        const firstNew = matching[limit]; limit += PAGE_SIZE; render(); saveState(); announce();
        if (firstNew && imageLink(firstNew)) imageLink(firstNew).focus({ preventScroll: true });
      });
      on(window, 'popstate', syncLocation);
      on(window, 'hashchange', syncLocation);
      on(window, 'pageshow', syncLocation);
      instances.set(root, { reveal, destroy: () => controller.abort() });
      controls.hidden = false;
      syncLocation();
    });
  }
  window.PVSeriesCatalog = {
    init,
    revealCard(id) {
      if (!productId(id)) return null;
      for (const instance of instances.values()) { const card = instance.reveal(id); if (card) return card; }
      return null;
    }
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { instances.forEach((instance, root) => { if (event.target === root || event.target.contains(root)) { instance.destroy(); instances.delete(root); } }); });
})();
